var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Matc"},[(_vm.isGuest &&!_vm.isPublic)?_c('LoginPage',{attrs:{"user":_vm.user},on:{"login":_vm.onLogin}}):_c('div',{staticClass:"MatcContainer"},[(_vm.hasHeader)?_c('Header',{attrs:{"user":_vm.user},on:{"login":_vm.onLogin,"logout":_vm.onLogout}}):_vm._e(),_c('router-view',{on:{"logout":_vm.onLogout}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }